<template>
  <div class="tdesk-container">
    <form class="small-form" @submit.prevent="calculatePlacesAvailable()">
      <p class="tdesk-paragraph-large" style="margin-bottom: 19px;">
        How many people are in this booking?
      </p>
      <label for="places_required">No. of participants</label>
      <div style="display:flex; flex-direction:row;">
        <input
          id="places_required"
          v-model="placesRequired"
          type="number"
          min="0"
          max="99"
          name="places_required"
          required
          style="max-width: 106px; margin-right: 13px;"
          class="tdesk-form-input"
        >
        <button class="tdesk-secondary-button" type="submit">
          <i class="fas fa-caret-right" />
          Next
        </button>
      </div>
    </form>
    <div
      v-if="error"
      class="tdesk-warn-ultradark tdesk-meta-small"
      style="margin-top: 11px; display: flex; align-items: center"
    >
      <i
        class="fas fa-exclamation-triangle tdesk-warn-ultradark"
        style="margin-right: 5px;"
      />
      {{ error }}
    </div>
    <div
      v-if="displayedError"
      class="tdesk-warn-ultradark tdesk-meta-small"
      style="margin-top: 11px; display: flex; align-items: center"
    >
      <i
        class="fas fa-exclamation-triangle tdesk-warn-ultradark"
        style="margin-right: 5px;"
      />
      <div>
        There {{ placesAvailable > 1 ? 'are' : 'is' }} only {{ placesAvailable }} {{ placesAvailable > 1 ? 'places' : 'place' }} available. Would you like to&nbsp;
        <a :href="calendarUrl" class="tdesk-info-ultradark text--underline">
          find a different course?
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import fireGaEvent from './fire_ga_event';

  export default {
    props: {
      courseId: {
        required: true,
        type: Number,
      },
      error: {
        required: false,
        type: String,
        default: null,
      },
    },
    data() {
      return {
        placesRequired: {
          type: Number,
          default: 0,
        },
        placesAvailable: {
          type: Number,
          default: 0,
        },
        displayedError: this.error,
        calendarUrl: Routes.self_signup_calendar_path(),
      };
    },
    methods: {
      calculatePlacesAvailable() {
        axios
            .get(Routes.calculate_places_remaining_path(this.courseId))
            .then(response => {
              this.$emit('clear-errors');
              this.displayedError = false;
              this.placesAvailable = response.data.places_remaining;

              if (this.placesAvailable === 0) {
                return this.$emit('raise-error');
              }
              if (this.placesRequired > this.placesAvailable) {
                return this.displayedError = true;
              }
              this.setPlacesRequired();
            });
      },
      setPlacesRequired() {
        if (!this.placesRequired) {
          return;
        }
        this.$emit('set-places-required', String(this.placesRequired).replace(/^0+/, ''));
        if (this.placesRequired === 1) {
          this.$emit('set-scope', 'individual');
        }
        fireGaEvent('ssbc_v2_step2a_number_of_participants');
        this.$emit('reserve-places');
      },
    },
  };
</script>
